import PerformanceImports from './PerformanceImports.jsx';

export const Imports = () => {
  return <PerformanceImports />;
};
